<template>
  <!--START SERVICES-->
  <section class="section pt-5 scroll-select" id="services">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 offset-lg-2">
          <h1 class="section-title text-center">Nossos Serviços</h1>
          <div class="section-title-border margin-t-20"></div>
          <p
            class="section-subtitle text-muted text-center padding-t-30 font-secondary"
          >
            Fornecemos uma curadoria de suas ideias, serviços de consultoria e
            marketing para alavancar o potencial de crescimento de sua startup.
          </p>
        </div>
      </div>
      <div class="row margin-t-30">
        <div class="col-lg-4 margin-t-20">
          <div class="services-box text-center hover-effect">
            <i class="pe-7s-diamond text-custom"></i>
            <h4 class="padding-t-15">Curadoria</h4>
            <p class="padding-t-15 text-muted">
              Sua ideia é especial como um diamante e precisa apenas de um toque
              de nossa experiência para ser lapidada.
            </p>
          </div>
        </div>
        <div class="col-lg-4 margin-t-20">
          <div class="services-box text-center hover-effect">
            <i class="pe-7s-display2 text-custom"></i>
            <h4 class="padding-t-15">
              Planejamento, Planejamento e Planejamento
            </h4>
            <p class="padding-t-15 text-muted">
              Nada de sair botando em prática aquilo que ainda esta em
              desenvolvimento. Nosso time tem o que é necessário para fortalecer
              o potencial de inovação de seu negócio.
            </p>
          </div>
        </div>
        <div class="col-lg-4 margin-t-20">
          <div class="services-box text-center hover-effect">
            <i class="pe-7s-piggy text-custom"></i>
            <h4 class="padding-t-15">Soluções Estratégicas</h4>
            <p class="padding-t-15 text-muted">
              Contamos com um portifólio com mais de 1000 startups iniciadas e
              para isso nossos profissionais estarão sempre à disposição para
              ajudá-lo em sua estratégia.
            </p>
          </div>
        </div>
      </div>
      <div class="row margin-t-30">
        <div class="col-lg-4 margin-t-20">
          <div class="services-box text-center hover-effect">
            <i class="pe-7s-science text-custom"></i>
            <h4 class="padding-t-15">Suporte</h4>
            <p class="padding-t-15 text-muted">
              Estaremos sempre a postos para ajudálo com implantações,
              migrações, websites e identidade visual.
            </p>
          </div>
        </div>
        <div class="col-lg-4 margin-t-20">
          <div class="services-box text-center hover-effect">
            <i class="pe-7s-news-paper text-custom"></i>
            <h4 class="padding-t-15">Marketing</h4>
            <p class="padding-t-15 text-muted">
              Não adianta nada ter um bom peixe se não souber vendê-lo.
              Criaremos toda a sua campanha de marketing e estratégia de mídias
              sociais.
            </p>
          </div>
        </div>
        <div class="col-lg-4 margin-t-20">
          <div class="services-box text-center hover-effect">
            <i class="pe-7s-plane text-custom"></i>
            <h4 class="padding-t-15">Voe conosco</h4>
            <p class="padding-t-15 text-muted">
              Nosso principal intuito é entregar ao mercado startups enxutas e
              com potencial ilimitado de crescimento e escalabilidade. Voe
              conosco e descubra como o mundo pode ser moldado pela sua ideia.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--START SERVICES-->
</template>

<script>
"use strict";
export default {
  name: "Services"
};
</script>
